'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const HailIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12.2 18C12.2 18.1 12.1 18.2 12 18.2M12.2 18C12.2 17.9 12.1 17.8 12 17.8M12.2 18H12M12 18.2C11.9 18.2 11.8 18.1 11.8 18M12 18.2V18M12 17.8C11.9 17.8 11.8 17.9 11.8 18M12 17.8V18M12 18H11.8M12 18L11.8 18.2M12 18L12.2 17.8M12 18L11.8 17.8M12 18L12.2 18.2M11.8 18.2C11.9 18.3 12.1 18.3 12.2 18.2M11.8 18.2C11.7 18.1 11.7 17.9 11.8 17.8M12.2 17.8C12.3 17.9 12.3 18.1 12.2 18.2M12.2 17.8C12.1 17.7 11.9 17.7 11.8 17.8M15.2 20C15.2 20.1 15.1 20.2 15 20.2M15.2 20C15.2 19.9 15.1 19.8 15 19.8M15.2 20H15M15 20.2C14.9 20.2 14.8 20.1 14.8 20M15 20.2V20M15 19.8C14.9 19.8 14.8 19.9 14.8 20M15 19.8V20M15 20H14.8M15 20L14.8 20.2M15 20L15.2 19.8M15 20L14.8 19.8M15 20L15.2 20.2M14.8 20.2C14.9 20.3 15.1 20.3 15.2 20.2M14.8 20.2C14.7 20.1 14.7 19.9 14.8 19.8M15.2 19.8C15.3 19.9 15.3 20.1 15.2 20.2M15.2 19.8C15.1 19.7 14.9 19.7 14.8 19.8M9.19995 20C9.19995 20.1 9.09995 20.2 8.99995 20.2M9.19995 20C9.19995 19.9 9.09995 19.8 8.99995 19.8M9.19995 20H8.99995M8.99995 20.2C8.89995 20.2 8.79995 20.1 8.79995 20M8.99995 20.2V20M8.99995 19.8C8.89995 19.8 8.79995 19.9 8.79995 20M8.99995 19.8V20M8.99995 20H8.79995M8.99995 20L8.79995 20.2M8.99995 20L9.19995 19.8M8.99995 20L8.79995 19.8M8.99995 20L9.19995 20.2M8.79995 20.2C8.89995 20.3 9.09995 20.3 9.19995 20.2M8.79995 20.2C8.69995 20.1 8.69995 19.9 8.79995 19.8M9.19995 19.8C9.29995 19.9 9.29995 20.1 9.19995 20.2M9.19995 19.8C9.09995 19.7 8.89995 19.7 8.79995 19.8M9.39995 15.2H16.1C18.4 15.2 20.2 13.3 20.2 11C20.2 8.70001 18.4 6.80001 16.1 6.80001C15.6 6.80001 15.1 6.90001 14.6 7.10001C13.7 5.10001 11.7 3.70001 9.39995 3.70001C6.29995 3.70001 3.69995 6.30001 3.69995 9.50001C3.79995 12.7 6.29995 15.2 9.39995 15.2Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpHailIcon = forwardRef(HailIcon);

export { VpHailIcon as default };
